import { useQuery } from '@apollo/client';
import { mapMoneyV2ToMoney } from '../../utils/money';
import { query } from './query';
import { ExchangeRateQuery } from './query.types';

export type Pair = keyof NonNullable<ExchangeRateQuery['clearing']>;

export const useExchangeRate = (pair: Pair) => {
  const { data, loading, error } = useQuery<ExchangeRateQuery>(query);

  return {
    rate: mapMoneyV2ToMoney(data?.clearing?.[pair]),
    loading,
    error,
  };
};
